import React from 'react';
import ReactDOM from 'react-dom';
import { Field,formValueSelector,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';
import Helpers from '../../../helpers/General.js';

const validate = values => {
    const errors = {}

    if (!values.email) {
        errors.email = 'Required'
    }else if(!Helpers.validateEmail(values.email)) {
    	errors.email = 'Invalid e-mail format';
    }

    if (!values.name) {
        errors.name = 'Required'
    }


    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const select = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

                                    

class EmailDetails extends React.Component {


    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">                       
                          
                                
                            <div className="row">
                                <div className="col-sm-6">
                                    <Field component={renderField} type="text" placeholder="Acme Inc" name="name"  className="form-control" title="Name" />
                                </div>

                                <div className="col-sm-6">
                                    <Field component={renderField} type="text" name="email" placeholder="support@acme.com" title="E-mail" className="form-control" />
                                </div>
                            </div>

                            <div className="col-sm-12 text-center">
                            <div className="form-group col-sm-8 offset-sm-2" style={{border: '1px solid #ccc',backgroundColor: '#fff',borderRadius: '5px',padding: '10px'}}>
	                                <label className="control-label">What your customers will see as sender in their inbox</label>
	                                <br />
	                                    <span className="sender-name" style={{fontWeight:'bold'}}>
	                                    	{this.props.name ? this.props.name:'Acme Inc'}
	                                    </span> 
	                                    &nbsp;&nbsp;
	                                    &lt; 
	                                    <span className="sender-email" style={{fontWeight:'bold'}}>
	                                    	{this.props.email ? this.props.email:'support@acme.com'}
	                                    </span> &gt;
	                            </div>
	                        </div>

                            <div className="row m-t-20">
                                <div className="col-sm-12">
                                    {
                                        this.props.isWaiting
                                        ?
                                        <LoadingSmall />
                                        :
                                        <button type="submit" className="btn btn-dark btn-block">Update</button>
                                    }
                                </div>
                            </div>
                </div>
                
            </form>
        );
    }
}
const selector = formValueSelector('EmailDetails');

const mapStateToProps = (state, ownProps) => ({

});


// Decorate the form component
EmailDetails = reduxForm({
  form: 'EmailDetails',
  validate,
})(EmailDetails);

EmailDetails = connect(
  state => ({
  	name:selector(state, 'name'),
  	email:selector(state, 'email'),
  	initialValues: {
        name: state.general.settings.EMAIL_SENDER_NAME,
        email:state.general.settings.EMAIL_SENDER_EMAIL,
      }
  })
)(EmailDetails)

export default EmailDetails;


// WEBPACK FOOTER //
// ./containers/settings/form/EmailDetails.js